import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 会员/企业列表
export const setOrgs: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.total = payload.total;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.loading = !!payload.loading;
};

// 沟通记录列表
export const setExchanges: Mutation<IModuleState> = (state, payload) => {
  state.exchanges.data = payload.data;
  state.exchanges.total = payload.total;
  state.exchanges.pageNum = payload.pageNum;
  state.exchanges.pageSize = payload.pageSize;
  state.exchanges.loading = !!payload.loading;
};

// 组织中已授权的品牌列表
export const setOrgAuthedBrands: Mutation<IModuleState> = (state, payload) => {
  state.authedBrands.data = payload.data;
  state.authedBrands.total = payload.total;
  state.authedBrands.pageNum = payload.pageNum;
  state.authedBrands.pageSize = payload.pageSize;
  state.authedBrands.loading = !!payload.loading;
};

// 组织中已保存的竞品品牌列表
export const setOrgCompetitors: Mutation<IModuleState> = (state, payload) => {
  state.competitors.data = payload.data;
  state.competitors.total = payload.total;
  state.competitors.pageNum = payload.pageNum;
  state.competitors.pageSize = payload.pageSize;
  state.competitors.loading = !!payload.loading;
};

// 客户类型列表
export const setOrgAdditionalTypes: Mutation<IModuleState> = (state, payload) => {
  state.orgAdditionalTypes.data = payload.data;
  state.orgAdditionalTypes.loading = !!payload.loading;
};

// 会员/企业详情
export const setOrgDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 计算好的价格
export const setPrice: Mutation<IModuleState> = (state, payload) => {
  state.price.data = payload.data;
  state.price.loading = !!payload.loading;
};

// 添加完成后的组织信息
export const setOrgInfo: Mutation<IModuleState> = (state, payload) => {
  state.orgInfo.data = payload.data;
  state.orgInfo.loading = !!payload.loading;
};

// 创建订单后后的订单信息
export const setOrderInfo: Mutation<IModuleState> = (state, payload) => {
  state.orderInfo.data = payload.data;
  state.orderInfo.loading = !!payload.loading;
};

// 检查组织里是否有激活的用户或自组织
export const setOrgChecked: Mutation<IModuleState> = (state, payload) => {
  state.orgChecked.data = payload.data;
  state.orgChecked.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.active = payload.active;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 普通弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 警告弹窗
export const setAlert: Mutation<IModuleState> = (state, payload) => {
  state.alert.content = payload.content;
  state.alert.visible = !!payload.visible;
  state.alert.loading = !!payload.loading;
};

// 设置步骤条数据
export const setStepData: Mutation<IModuleState> = (state, payload) => {
  state.step.step1 = payload.step1;
  state.step.step2 = payload.step2;
  state.step.step3 = payload.step3;
  state.step.step5 = payload.step5;
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
